export const formatMessageDateFromTimestamp = (timestamp: number) => {
    if (!timestamp) {
      return '';
    }
  
    const messageDate = new Date(timestamp);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const day = messageDate.getDate();
    const month = messageDate.toLocaleString(undefined, { month: 'long' });
  
    // Function to determine the ordinal suffix (st, nd, rd, th)
    const getOrdinalSuffix = (day: number) => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
    const formattedDate = `${day}${getOrdinalSuffix(day)} ${month}`;
  
    if (messageDate >= today) {
      return 'Today';
    } else if (messageDate >= yesterday && messageDate < today) {
      return 'Yesterday';
    } else {
      return formattedDate; 
    }
  };
  